export default "__VITE_ASSET__u$oK7DXw__"